import { getElement } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class TopBarAside {
  private readonly element: HTMLElement | null
  private readonly scrollThreshold = 80

  constructor() {
    this.element = getElement('top-bar-aside')
  }

  public init(): void {
    if (this.element === null) {
      return
    }

    this.update()
    this.addEvents()
  }

  private addEvents(): void {
    window.addEventListener('scroll', (): void => this.update(), { passive: true })
    window.addEventListener('resize', (): void => this.update(), { passive: true })
  }

  private update(): void {
    this.element.classList.toggle(IS_ACTIVE, window.scrollY > this.scrollThreshold)
    const bottom = this.element.getBoundingClientRect().bottom
    document.documentElement.style.setProperty('--top-bar-aside-bottom', `${bottom}px`)
  }
}

const topBarAside = new TopBarAside()
topBarAside.init()
